/*
 *
 * SurveysImport constants
 *
 */

export const GET_TEMPLATE_SURVEY_WATCHER =
  "app/SurveyImport/GET_TEMPLATE_DIVISION_WATCHER"
export const GET_TEMPLATE_FAILED = "app/SurveyImport/GET_TEMPLATE_FAILED"
export const GET_TEMPLATE_SUCCESS = "app/SurveyImport/GET_TEMPLATE_SUCCESS"

export const SAVE_TEMPLATE_WATCHER =
  "app/SurveyImport/SAVE_TEMPLATE_DIVISION_WATCHER"
export const SAVE_TEMPLATE_SUCCESS = "app/SurveyImport/SAVE_TEMPLATE_SUCCESS"
export const SAVE_TEMPLATE_CEASED_WATCHER =
  "app/SurveyImport/SAVE_TEMPLATE_CEASED_WATCHER"
export const SAVE_TEMPLATE_PROGRESS = "app/SurveyImport/SAVE_TEMPLATE_PROGRESS"
export const SAVE_TEMPLATE_CEASED_PROGRESS =
  "app/SurveyImport/SAVE_TEMPLATE_CEASED_PROGRESS"

export const UPLOAD_TEMPLATE_WATCHER =
  "app/SurveyImport/UPLOAD_TEMPLATE_WATCHER"
export const UPLOAD_TEMPLATE_SUCCESS =
  "app/SurveyImport/UPLOAD_TEMPLATE_SUCCESS"
export const UPLOAD_TEMPLATE_FAILED = "app/SurveyImport/UPLOAD_TEMPLATE_FAILED"

export const GET_SURVEY_SUMMARY_WATCHER =
  "app/SurveyImport/GET_SURVEY_SUMMARY_WATCHER"
export const GET_SURVEY_SUMMARY_SUCCESS =
  "app/SurveyImport/GET_SURVEY_SUMMARY_SUCCESS"
export const GET_SURVEY_SUMMARY_FAILED =
  "app/SurveyImport/GET_SURVEY_SUMMARY_FAILED"
